<template>
  <tr class="text-center align-middle">
    <td>{{ item.pax }}</td>
    <td>
      <!-- <ValidationObserver ref="form">
        <vue-input
          input-class="table-form-control text-center"
          v-model="item.precio"
          rules="double"
          name="Tarifa"
          mode="passive"
        ></vue-input>
      </ValidationObserver> -->
      <InputText
        v-model="item.precio"
        rules="number"
        name="Tarifa"
        :errorMode="'tooltip'"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
  </tr>
</template>
<script>
import InputText from '../modules/shared/components/InputText.vue'
export default {
  components: { InputText
  },
  props: {
    item: Object,
  },
  data () {
    return {
      containers: {
        edit: false,
      },
      loading: {
        save: false
      }
    }
  },
  methods: {
  }
}
</script>